import { render, staticRenderFns } from "./replyBox.vue?vue&type=template&id=4dc8e178&scoped=true"
import script from "./replyBox.vue?vue&type=script&lang=js"
export * from "./replyBox.vue?vue&type=script&lang=js"
import style0 from "./replyBox.vue?vue&type=style&index=0&id=4dc8e178&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc8e178",
  null
  
)

export default component.exports